import { Box } from "@mui/material"
import { Position } from "reactflow"
import { INodeData } from "../../index"
import CustomHandler from "../../Helpers/CustomHandler"

export default function NodeInicio({ data }: INodeData) {
    return (
        <>
            <Box
                width={60}
                height={60}
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="50%"
                color="#fff"
                bgcolor="#007bff"
                border={`2px solid rgba(0,0,0, ${data.isClicked ? "0.7" : "0.2"})`}
            >
                Inicio
            </Box>
            <CustomHandler type="source" id="source-right" position={Position.Right} />
        </>
    )
}